exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".topic-description {\n    padding-left: 10px;\n    font-size: 13px;\n}\n.load-wating{\nfloat: left;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/topic-follow/topic-follow.component.css
// module id = ../../../../../src/app/home/topic-follow/topic-follow.component.css
// module chunks = common